import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH TAGS_ITEM TO EDIT ********************
export const fetchTagsItem = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_TAGS_ITEM_LOADING,
			payload: true
		});

		const response = await services.get(`/tags/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_TAGS_ITEM_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_TAGS_ITEM_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
